<script>
import { reactive, ref } from 'vue';

export default {
  components: {
  },
  props: {
    appThemeBrand: {
      type: String,
      default: 'default'
    },
    appTitle: {
      type: String,
      default: ''
    }
  },
  setup() {
    const pageTitleWhitelabels = ref([ // White labels that show a custom page title
      'pflegegrad-beantragen',
      'seniorenportal',
      'bad-bramstedt',
      'zwickauer-energieversorgung',
      'mitpflegeleben',
      'swd',
      'burda',
      'pflegedienst-angela',
      'stadtwerke-heide',
      'stadtwerke-greven',
      'zbvv',
      'spiribo',
      'sanimed',
      'seniorenfocus',
      'corporatebenefits',
      'seniorenfocus-nord',
      'seniorenfocus-bawue',
      'seniorenfocus-ndsb',
      'landingpage-bawue-messe',
    ]);

    const pageLogoWhitelabels = reactive({ // White labels that have logos
      meravis: {
        whiteLabelLogoClass: 'meravis-logo',
        johanniterLogoClass: 'johanniter-logo'
      },
      'harz-energie': {
        whiteLabelLogoClass: 'harz-energie-logo',
        johanniterLogoClass: 'johanniter-logo'
      },
      stadtwerkeneuss: {
        whiteLabelLogoClass: 'logo-left',
        johanniterLogoClass: 'logo-right'
      },
      thuegaenergie: {
        whiteLabelLogoClass: 'thuegaenergie-logo',
        johanniterLogoClass: ''
      },
      stadtwerkewertheim: {
        whiteLabelLogoClass: 'logo-left-stadtwerkewertheim',
        johanniterLogoClass: 'logo-right-johanniter'
      },
      swg: {
        whiteLabelLogoClass: 'logo-left-swg',
        johanniterLogoClass: 'logo-right-johanniter'
      },
      'aue-bad-schlema': {
        whiteLabelLogoClass: 'logo-left-aue-bad-schlema',
        johanniterLogoClass: 'logo-right-johanniter'
      },
      'bad-bramstedt': {
        whiteLabelLogoClass: 'logo-left-bad-bramstedt',
        johanniterLogoClass: 'logo-right-johanniter'
      },
      'zwickauer-energieversorgung': {
        whiteLabelLogoClass: 'logo-left-zwickauer-energieversorgung',
        johanniterLogoClass: 'logo-right-johanniter'
      },
      swd: {
        whiteLabelLogoClass: 'logo-left-swd',
        johanniterLogoClass: 'logo-right-johanniter logo-right-johanniter-swd'
      },
      'pflegedienst-angela': {
        whiteLabelLogoClass: 'logo-left-pflegedienst-angela-logo',
        johanniterLogoClass: 'logo-right-johanniter'
      },
      'stadtwerke-heide': {
        whiteLabelLogoClass: 'logo-left-stadtwerke-heide',
        johanniterLogoClass: 'logo-right-johanniter'
      },
      'stadtwerke-greven': {
        whiteLabelLogoClass: 'logo-left-stadtwerke-greven-logo',
        johanniterLogoClass: 'logo-right-johanniter'
      },
      zbvv: {
        whiteLabelLogoClass: 'logo-left-zbvv-logo',
        johanniterLogoClass: 'logo-right-johanniter'
      },
      spiribo: {
        whiteLabelLogoClass: '',
        johanniterLogoClass: 'logo-right-johanniter'
      },
      wemag: {
        whiteLabelLogoClass: 'wemag-logo',
        johanniterLogoClass: ''
      },
      agfh: {
        whiteLabelLogoClass: 'agfh-logo',
        johanniterLogoClass: ''
      },
    });
    return {
      pageTitleWhitelabels,
      pageLogoWhitelabels
    }
  }
}
</script>

<template>
  <div class="header">
    <div v-if="pageTitleWhitelabels.includes(appThemeBrand)">
      <h1 class="header__heading u-margin-bottom-medium u-text-center">{{ appTitle }}</h1>
    </div>

    <div v-if="pageLogoWhitelabels.hasOwnProperty(appThemeBrand)">
      <div class="logos">
        <div :class="pageLogoWhitelabels[appThemeBrand]?.whiteLabelLogoClass"></div>
        <div :class="pageLogoWhitelabels[appThemeBrand]?.johanniterLogoClass"></div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">

</style>
